export class MaterialWhereUsed {
  public constructor(
    public material: string,
    public materialType: string,
    public description: string,
    public materialGroup: string,
    public globalLaunchDate?: Date,
    public marketExitDate?: Date
  ) {}
}
